import { supabase } from "@/integrations/supabase/client";
import {
  canCreateBrandForTier,
  getBrandLimitReachedMessage,
  getTierBrandLimit,
  normalizeTier,
  type SubscriptionTier,
} from "@/lib/tierUtils";

export interface BrandLimitStatus {
  tier: SubscriptionTier;
  brandCount: number;
  limit: number | null;
  canCreate: boolean;
  reachedMessage: string | null;
}

export async function fetchBrandLimitStatus(userId: string): Promise<BrandLimitStatus> {
  const [{ data: credits, error: creditsError }, { count, error: brandsError }] = await Promise.all([
    supabase
      .from("user_credits")
      .select("subscription_tier")
      .eq("user_id", userId)
      .maybeSingle(),
    supabase
      .from("brand_profiles")
      .select("id", { count: "exact", head: true })
      .eq("user_id", userId),
  ]);

  if (creditsError) {
    throw creditsError;
  }

  if (brandsError) {
    throw brandsError;
  }

  const tier = normalizeTier(credits?.subscription_tier);
  const brandCount = count ?? 0;
  const limit = getTierBrandLimit(tier);
  const canCreate = canCreateBrandForTier(tier, brandCount);

  return {
    tier,
    brandCount,
    limit,
    canCreate,
    reachedMessage: canCreate ? null : getBrandLimitReachedMessage(tier),
  };
}
